import { brandInfo } from '@/mocks/home';

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
          {brandInfo.stats.map((stat, idx) => (
            <div
              key={stat.label}
              className="text-center p-5 md:p-7 rounded-2xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-primary-200"
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${stat.icon} text-xl text-primary-600`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                {stat.value}
              </div>
              <div className="mt-1 text-sm text-foreground-500">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}